import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import { numberToSup } from '@utils/formatNumber';

import PriceText from '@common/components/PriceText';
import { OFFER_TYPES } from '@common/constants/filters';
import { PriceCrossed, PriceSmall } from '@common/components/ProductComponents';

import { Price } from './Pricing.styled';

const Pricing = ({ price, offerType, specialPrice, isExpired }) => {
  const { t } = useTranslation();
  const isSale = offerType === OFFER_TYPES.SALE;
  const isMoment = offerType === OFFER_TYPES.MOMENT;
  const isOffer =
    offerType === OFFER_TYPES.OFFER || offerType === OFFER_TYPES.VIPOFFER;

  return (
    <>
      {((isSale && price) || (isMoment && specialPrice)) && (
        <PriceCrossed data-testid="productPriceCrossed">
          <PriceText>{`CHF ${numberToSup(price)}`}</PriceText>
        </PriceCrossed>
      )}
      {isOffer && price && (
        <PriceSmall>
          <PriceText>
            {`${t('product.offer.discount', 'statt CHF')} ${numberToSup(price)}`}
          </PriceText>
        </PriceSmall>
      )}
      <Price
        data-testid="productPrice"
        isSale={isSale}
        isMoment={isMoment}
        isExpired={isExpired}
      >
        <PriceText>{`CHF ${numberToSup(specialPrice || price)}`}</PriceText>
      </Price>
    </>
  );
};

Pricing.propTypes = {
  price: PropTypes.number,
  offerType: PropTypes.oneOf(Object.values(OFFER_TYPES)),
  specialPrice: PropTypes.number,
  isExpired: PropTypes.bool,
};

Pricing.defaultProps = {
  price: 0,
  offerType: null,
  specialPrice: 0,
  isExpired: false,
};

export default Pricing;
